<template>
  <v-container>
    <v-progress-circular
      indeterminate
      class="loading"
      color="primary"
      v-if="loading"
    >
      Cargando
    </v-progress-circular>
    <div
      v-else
      class="public-form"
      :class="{ 'public-form-print': data != undefined }"
    >
      <v-col>
        <p
          class="ministerio"
          :class="{ 'ministerio-print': data != undefined }"
        >
          MINISTERIO DE ECONOMÍA PLANIFICACIÓN Y DESARROLLO (MEPyD)
        </p>
        <v-row align="center" style="margin-bottom: 1%; margin-top: 1%">
          <img class="shield" src="@/assets/escudo.png" />

          <p
            class="one-tittle"
            :class="{ 'one-tittle-print': data != undefined }"
          >
            Oficina Nacional de Estadística
          </p>

          <img class="one-logo" src="@/assets/one_logo_transparent.png" />
        </v-row>
      </v-col>

      <hr class="divider" style="margin-top: -1%" />

      <div class="group-2">
        <p class="sub-tittle">Capitulo I: Identificación del registro</p>
      </div>
      <v-col>
        <v-row align="center" v-if="form.id != null">
          <v-card-title class="question">1.1 Id del formulario</v-card-title>
          <label class="answer"> {{ form.id }} </label>
        </v-row>
        <v-row style="padding-top: 0" align="center" v-if="form.name != null">
          <v-card-title class="question"
            >1.2 Nombre del registro administrativo</v-card-title
          >
          <label class="answer"> {{ form.name }} </label>
        </v-row>
        <v-row align="center" v-if="form.organization != null">
          <v-card-title class="question"
            >1.3 Nombre de la institución responsable del registro</v-card-title
          >

          <label class="answer">
            {{ form.organization }}
          </label>
        </v-row>
        <v-row align="center" v-if="form.productUnit != null">
          <v-card-title class="question">1.3.1 Unidad productora</v-card-title>
          <label class="answer"> {{ form.productUnit }} </label>
        </v-row>
        <v-row align="center" v-if="form.domain != null">
          <v-card-title class="question"
            >1.4 Dominio de actividad estadística</v-card-title
          >
          <label class="answer"> {{ form.domain }} </label>
        </v-row>
        <v-row align="center" v-if="form.sector != null">
          <v-card-title class="question">1.4.2 Sector</v-card-title>

          <label class="answer"> {{ form.sector }} </label>
        </v-row>
      </v-col>

      <hr class="divider" />
      <div class="group-2">
        <p class="sub-tittle">Capitulo II: Aspectos generales del R.A</p>
      </div>
      <v-col>
        <v-col v-if="form.goal != null">
          <v-card-title class="questionGeneral"
            >2.2 Objetivo del registro administrativo</v-card-title
          >

          <label class="answerGeneral"> {{ form.goal }} </label>
        </v-col>

        <v-col v-if="form.observationUnit != null">
          <v-card-title class="questionGeneral"
            >2.3 Unidad de observación del registro administrativo</v-card-title
          >

          <label class="answerGeneral"> {{ form.observationUnit }} </label>
        </v-col>
        <v-col align="center" v-if="form.allVariables != null">
          <v-card-title class="questionGeneral"> </v-card-title>

          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 2%"
            :question="variableQuestion"
            :answer="form.allVariables"
            :disabledAnswers="true"
          />
        </v-col>
        <v-col v-if="form.geography != null">
          <v-card-title class="questionGeneral"
            >2.5 Cobertura geográfica del R.A</v-card-title
          >

          <label class="answerGeneral">
            {{ form.geography }}
          </label>
        </v-col>

        <v-col v-if="form.Division != null">
          <v-card-title class="questionGeneral"
            >2.6 división territorial usada en R.A</v-card-title
          >

          <label class="answerGeneral">
            {{ form.Division }}
          </label>
        </v-col>

        <v-col v-if="form.desgagregationVariables != null">
          <v-card-title style="width: 60%" class="questionGeneral"
            >2.6.1 Variables de desagración territorial incluidas en el
            registro</v-card-title
          >

          <label class="answerGeneral">
            {{ form.desgagregationVariables }}
          </label>
        </v-col>
      </v-col>

      <hr class="divider chap-3" />
      <div class="group-3">
        <p class="sub-tittle">Capitulo III: Recolección de los datos</p>
      </div>
      <v-col>
        <v-col v-if="form.recolectionTechnic != null">
          <v-card-title class="questionGeneral"
            >3.2 ¿Cuál es la tecnica recoleccion Utilizada?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.recolectionTechnic }}
          </label>
        </v-col>

        <v-col v-if="form.recolectionMethod != null">
          <v-card-title class="questionGeneral"
            >3.3 ¿Qué medio (s) se utilizan para la recoleccion de los
            datos?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.recolectionMethod }}
          </label>
        </v-col>
      </v-col>

      <!--IV -->
      <hr class="divider" />
      <div class="group-3">
        <p class="sub-tittle">
          Capitulo IV: Almacenamiento, interoperabilidad y accesibilidad a
          microdatos
        </p>
      </div>
      <v-col>
        <v-col v-if="haveData(form.dataStored)">
          <v-card-title class="questionGeneral"
            >4.1 ¿Los datos levantados son almacenados?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.dataStored }}
          </label>
        </v-col>
        <v-col align="center" v-if="haveData(form.storeCombined)">
          <v-card-title class="questionGeneral"> </v-card-title>

          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 2%"
            :question="storeQuestion"
            :answer="form.storeCombined"
            :disabledAnswers="true"
          />
        </v-col>
      </v-col>

      <!--V -->
      <hr class="divider" />
      <div class="group-3">
        <p class="sub-tittle">Capitulo V: Acceso a microdatos</p>
      </div>
      <v-col>
        <v-col v-if="form.dataDisponibility != null">
          <v-card-title class="questionGeneral"
            >5.1 ¿La base de datos o los archivos electrónicos están
            disponibles?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.dataDisponibility }}
          </label>
        </v-col>
        <v-col v-if="form.accessMethod != null">
          <v-card-title class="questionGeneral">
            5.1.1 Medio de accesibilidad</v-card-title
          >
          <label class="answerGeneral">
            {{ form.accessMethod }}
          </label>
        </v-col>
      </v-col>

      <hr class="divider" />
      <div class="group-3">
        <p class="sub-tittle">Capitulo VI: Marco conceptual y metodológico</p>
      </div>

      <v-col>
        <v-col v-if="form.regulations != null">
          <v-card-title class="questionGeneral"
            >6.1 ¿Existen regulaciones para el desarrollo y uso de este
            R.A?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.regulations }}
          </label>
        </v-col>

        <v-col v-if="form.variableIncludedConfirmation != null">
          <v-card-title class="questionGeneral"
            >6.4 Las variables y categorías incluidas en este registro
            administrativo están definidas en correspondencia con algún
            instrumento normativo, regulatorio o metodológico</v-card-title
          >

          <label class="answerGeneral">
            {{ form.variableIncludedConfirmation }}
          </label>
        </v-col>
        <v-col align="center" v-if="form.variableIncluded != null">
          <v-card-title class="questionGeneral"> </v-card-title>

          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 2%"
            :question="variableIncludedQuestion"
            :answer="form.variableIncluded"
            :disabledAnswers="true"
          />
        </v-col>

        <v-col v-if="form.clasificationConfirmation != null">
          <v-card-title class="questionGeneral"
            >6.5 ¿En este R.A se utiliza alguna clasificación?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.clasificationConfirmation }}
          </label>
        </v-col>

        <v-col align="center" v-if="form.clasification != null">
          <v-card-title class="questionGeneral"> </v-card-title>

          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 2%"
            :question="clasificationQuestion"
            :answer="form.clasification"
            :disabledAnswers="true"
          />
        </v-col>
      </v-col>

      <hr class="divider chap-7" />
      <div class="group-3">
        <p class="sub-tittle">Capitulo VII: Uso y demanda del R.A</p>
      </div>
      <v-col>
        <v-col v-if="form.statisticalPurposes != null">
          <v-card-title class="questionGeneral"
            >7.1 El registro es producido con fines estadísticos</v-card-title
          >

          <label class="answerGeneral">
            {{ form.statisticalPurposes }}
          </label>
        </v-col>

        <v-col align="center" v-if="form.statisticalUse != null">
          <v-card-title class="questionGeneral"> </v-card-title>

          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 2%"
            :question="statisticalUseQuestion"
            :answer="form.statisticalUse"
            :disabledAnswers="true"
          />
        </v-col>

        <v-col v-if="form.demandProduction != null">
          <v-card-title class="questionGeneral"
            >7.2 ¿Con este registro se producen o pueden producirse estadísticas
            para responder a los indicadores de instrumentos de
            demanda?</v-card-title
          >

          <label class="answerGeneral">
            {{ form.demandProduction }}
          </label>
        </v-col>

        <v-col align="center" v-if="form.instrumentsIndicator != null">
          <v-card-title class="questionGeneral"> </v-card-title>
          <tableAnswerComponentVue
            style="margin-top: 2%; margin-bottom: 3%"
            :question="instrumentsIndicatorQuestion"
            :answer="form.instrumentsIndicator"
            :disabledAnswers="true"
          />
        </v-col>
      </v-col>

      <hr class="divider last-chapter" />
      <div class="group-3">
        <p class="sub-tittle">Capitulo IX: Del Levantamiento</p>
      </div>
      <v-col>
        <v-col v-if="form.liftingDate != null">
          <label class="questionGeneral">Fecha de levantamiento</label>

          <v-text-field
            class="disabled-text"
            v-model="form.liftingDate"
            :disabled="true"
          />
        </v-col>

        <v-col v-if="haveData(form.observations)">
          <label class="questionGeneral">Observaciones</label>
          <v-text-field
            class="disabled-text"
            v-model="form.observations"
            :disabled="true"
        /></v-col>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { getPublicForm } from "@/utils/apiRequest.js";
import tableAnswerComponentVue from "@/components/tableAnswerComponent.vue";
export default {
  data() {
    return {
      form: {},
      organization: "",
      user: {},
      loading: true,
      variableQuestion: {
        question:
          "2.4 Nombre de todas las variables levantadas por el registro administrativo",
        options: "Variable;Categoría",
      },
      statisticalUseQuestion: {
        question: "7.1.1 ¿Cual es su uso estadistico?",
        options:
          "Nombre del producto y/o operación estadística;Institución que lo produce;Código IOE;Responde a indicadores de la Demanda",
      },
      instrumentsIndicatorQuestion: {
        question:
          "7.3 ¿Cuáles indicadores de los instrumentos de demanda son producidos o pueden producirse en este registro?",
        options: "Indicador;Fuente de demanda",
      },

      variableIncludedQuestion: {
        question:
          "Las variables y categorías incluidas en este registro administrativo están definidas en correspondencia con algún instrumento  normativo, regulatorio o metodológico",
        options: "Nombre del documento;Alcance;Verificación del documento",
      },
      clasificationQuestion: {
        question: "6.5.1 Utilización de alguna clasificación",
        options: "Nombre de la clasificación;Alcance;Versión;Año",
      },
      storeQuestion: {
        question: "Almacenamientos de las bases de datos utilizadas",
        options:
          "Base de datos estructurada;Archivo electronico de base de datos no estructurado",
      },
    };
  },
  components: {
    tableAnswerComponentVue,
  },
  props: {
    data: Object(),
  },
  methods: {
    setFormData() {
      this.user = this.form.user;
      this.variableQuestion.answer = this.form.allVariables;
      this.loading = false;
      this.form.storeCombined =
        this.form.noStructDatabase + ";" + this.form.structDatabase;
      this.form.storeCombined = this.form.storeCombined.replaceAll(
        "undefined",
        ""
      );
      this.form.storeCombined = this.form.storeCombined.replaceAll("null", "");
    },
    haveData(text) {
      return text != null && text.length > 1;
    },
  },

  async mounted() {
    if (this.data != undefined) {
      this.form = this.data;
      this.setFormData();
      return;
    }
    let response = await getPublicForm(this.$route.params.id);
    if (response.data.status == "success") {
      this.form = response.data.publicForm;
      this.setFormData();
    }

    if (window.location.hash == "#print") {
      await new Promise((resolve) => setTimeout(resolve, 450));
      document.title = this.form.id;
      window.print();
      window.close();
    }
  },
};
</script>
<style lang="scss" scoped>
@media print {
  div .v-card {
    page-break-inside: avoid;
  }

  .v-list-item__content {
    page-break-inside: avoid;
  }

  div .last-chapter {
    margin-top: 22%;
  }
}

.public-form {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 1000px;
  min-width: 1000px;
  margin-left: -1%;
}

.public-form-print {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 800px;
  min-width: 800px;
  margin-left: -1%;
}

.disabled-text {
  font-weight: 500;
  color: black;
  -webkit-text-fill-color: black;
}

.ministerio {
  font-weight: bold;
  margin: 0 0 -2% 25%;
  font-size: smaller;
}

.ministerio-print {
  font-weight: bold;
  margin: 0 0 0 15%;
  font-size: smaller;
}

.one-tittle {
  font-weight: bolder;
  margin: 0 0 0 30%;
}
.one-tittle-print {
  font-weight: bolder;
  margin: 0 0 0 20%;
}

.shield {
  width: 60px;
  height: 60px;
  margin-left: 1%;
}

.one-logo {
  width: 90px;
  height: 50px;
  margin-left: 30%;
}

.relative-wrapper-one {
  height: 25.98%;
  margin-bottom: 47.67px;
  align-self: stretch;
  position: relative;
}

.relative-wrapper-one-2 {
  height: 25.98%;
  margin-bottom: 47.67px;
  align-self: stretch;
  position: relative;
  margin-top: 3%;
}
.group-1 {
  position: relative;
  font-weight: bolder;
}

.group-2 {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 810px;
  font-weight: bolder;
}

.group-3 {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 810px;
  margin-top: 3%;
  font-weight: bolder;
}
.sub-tittle {
  height: 100%;
  width: 100%;
  color: black;
  display: flex;
  align-items: center;
  font-weight: bolder;
  margin: 0 0 0 40%;
  padding-bottom: 2%;
  word-break: normal;
}

.questionGeneral {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 100%;
  font-weight: bold;
  margin-left: 1.5%;
}

.answerGeneral {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: normal;
  width: 100%;
  margin-left: 3%;
}
.text-answer {
  margin-left: 10px;
  display: flex;
  align-items: flex-start;
  &:not(:last-of-type) {
    margin-bottom: 17px;
  }
}
.text {
  color: black;
  text-align: center;
  margin-right: 297px;
}
.line-1 {
  width: 273px;
  height: 1px;
  background-color: black;
  margin-top: 15.5px;
  margin-left: auto;
}
.text-two {
  color: black;
  text-align: center;
  margin-right: 38px;
}
.line-1-two {
  width: 273px;
  height: 1px;
  background-color: black;
  margin-top: 15px;
  margin-left: auto;
}
.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}

.question {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: normal;
  width: 60%;
  font-weight: bold;
}

.answer {
  font-size: medium;
  word-break: normal;
  width: 40%;
}

.v-card__title {
  padding: 2px;
}

.divider {
  margin-top: 3%;
  width: 100%;
  height: 4px;
  color: black;
  background-color: black;
  border-width: 100%;
}

#nav {
  display: none;
}
</style>